import React from "react"

import styles from "./styles.module.scss"

const SearchBar = ({ placeholder, value, onChange }) => {
  return (
    <form onSubmit={e => e.preventDefault()} className={styles.searchForm}>
      <input type="search" placeholder={placeholder || null} defaultValue={value || ''} onChange={onChange} />
      <button type="submit"><i className="fas fa-search"></i></button>
    </form>
  )
}

export default SearchBar
